import { useMutation } from 'react-query';
import { putPracticeChartInfo } from 'apis/chart/studentPracticeChart';
import { putEvaluationChartInfo } from 'apis/chart/studentEvaluationChart';
import { isTCustomAxiosError } from 'apis/config/axios';
import useModal from 'hooks/useModal';
import useGoBack from 'hooks/useGoBack';

type TProps = {
  category: string;
  id: number;
  data: FormData;
  isAutoSave?: boolean;
  patientId?: string;
  courseInfoId?: string;
  chartRound?: string;
  onLoading?: (isLoading: boolean) => void;
};

const useChartMutation = (afterAutoSave?: (data: any) => void) => {
  const { openModal, closeModal } = useModal();
  const goBack = useGoBack();

  const { mutate: chartMutation } = useMutation(
    async ({ category, id, data }: TProps) => {
      switch (category) {
        case 'practice': {
          const response = await putPracticeChartInfo(id, data);
          return response;
        }
        case 'evaluation': {
          const response = await putEvaluationChartInfo(id, data);
          return response;
        }
        default:
          return Promise.reject();
      }
    },
    {
      onSuccess: (data, context) => {
        const { category, isAutoSave, patientId, courseInfoId, chartRound } =
          context;
        if (!isAutoSave) {
          goBack(
            category !== 'practice'
              ? {
                  patientId,
                  courseInfoId,
                  chartRound,
                }
              : {}
          );
        } else {
          afterAutoSave && afterAutoSave(data);
        }
      },
      onError: (error, context) => {
        const { isAutoSave, onLoading } = context;
        if (isAutoSave) return;
        closeModal();
        openModal({
          title: '차트 등록 실패',
          text: isTCustomAxiosError(error)
            ? error.data?.toString() || error.message
            : '다시 시도해 주세요.',
        });
        onLoading && onLoading(false);
      },
    }
  );

  return { chartMutation };
};

export default useChartMutation;
